import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes } from '../../../../types/common/types';
import { translateFn } from '../../../../utils/translator.helper';
import { ButtonColors, ButtonTypes } from '../../../../ui/gzButton/types';
import { GzDialogEvents } from '../../../../ui/gzDialog/component/GzDialog';

/**
 * @summary Delete view dialog content
 * @tag gz-dashboard-delete-view-dialog-content
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-dashboard-delete-view-dialog-content')
export class GzDashboardDeleteViewDialogContentWebComponent extends LitElement {
  public viewName: string;
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <gz-text class="pb-4" fontSize="${FontSizes.HEADING_6}">
        ${translateFn('Deleting {viewName} will remove its entry from the Custom section.', {
          viewName: this.viewName,
        })}
      </gz-text>
      <div class="action-buttons">
        <gz-button
          type="${ButtonTypes.OUTLINE}"
          color="${ButtonColors.NEGATIVE}"
          id="deleteButton"
          class="mr-2"
          @click="${this.handleDeleteButton}"
        >
          ${translateFn('Delete')}
        </gz-button>

        <gz-button type="${ButtonTypes.OUTLINE}" color="${ButtonColors.SECONDARY}" @click="${this.handleCancelButton}">
          ${translateFn('Cancel')}
        </gz-button>
      </div>
    `;
  }

  private handleDeleteButton() {
    this.dispatchEvent(
      new CustomEvent(GzDialogEvents.CONFIRM, {
        bubbles: true,
        composed: true,
      })
    );
  }

  private handleCancelButton() {
    this.dispatchEvent(
      new CustomEvent(GzDialogEvents.CANCEL, {
        bubbles: true,
        composed: true,
      })
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-dashboard-delete-view-dialog-content': GzDashboardDeleteViewDialogContentWebComponent;
  }
}
